import React, { useState } from "react";
import {
  MyMessage,
  InputField,
  AddPageShell,
  AddSection,
} from "../../components/Component";
import { codeOk } from "../../../lib/index";
import { useDoSeeDataContext } from "../../../context/DoSeeDataContext";
import { getOneCityGuide } from "../../../lib/sysNavigation/SysNavigation";
import { FOLDERS, image_kit_folder } from "../utils/Utils";
import { defaultImage } from "../../../lib/libraries/imageKit/ImageKit";
import { ImageKitUpload } from "../../../ui/ImageKitLibrary";
import { useGeoPositionContext } from "../utils/geoPosition";
import { _TYPES_ } from "../utils/types";
import Pricing from "../../components/Pricing";
import GenerateDescription from "../utils/GenerateDescription";
import {
  ContactSection,
  SocialSection,
  GeoSection,
  VisibilitySection,
  DescriptionSection,
} from "../utils/AddSections";
import { FiImage, FiClock, FiMap, FiDollarSign } from "react-icons/fi";

const slugify = (s: any) =>
  s
    ? s
        .toString()
        .trim()
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, "_")
        .replace(/^_+|_+$/g, "")
    : null;

const Edit = () => {
  const { updateOneContent } = useDoSeeDataContext();
  const {
    country_id,
    entry_label,
    country_name,
    first_level_id,
    fourth_level_id,
    second_level_id,
    third_level_id,
  } = useGeoPositionContext();

  const cityguide: any = getOneCityGuide();

  const city_guide_id = cityguide?.city_guide_id;
  const [thumbnail, setThumbnail] = useState<any>(cityguide?.thumbnail);
  const [thumbnailId, setThumbnailId] = useState<any>(cityguide?.image_cdn_id);
  const [title, setTitle] = useState<any>(cityguide?.title || "");
  const [venue, setVenue] = useState<any>(cityguide?.venue || "");
  const [venueCapacity, setVenueCapacity] = useState<any>(
    cityguide?.venue_capacity ?? ""
  );
  const [startDate, setStartDate] = useState<any>(cityguide?.start_date || "");
  const [endDate, setEndDate] = useState<any>(cityguide?.end_date || "");
  const [startTime, setStartTime] = useState<any>(cityguide?.start_time || "");
  const [endTime, setEndTime] = useState<any>(cityguide?.end_time || "");

  const [email, setEmail] = useState<any>(cityguide?.email_address || "");
  const [payLink, setPayLink] = useState<any>(cityguide?.pay_link);
  const [phoneNumber, setPhoneNumber] = useState<any>(
    cityguide?.phone_number || ""
  );

  const [whatsapp, setWhatsapp] = useState<any>(cityguide?.whatsapp || "");
  const [facebook, setFacebook] = useState<any>(cityguide?.facebook || "");
  const [twitter, setTwitter] = useState<any>(cityguide?.twitter || "");
  const [instagram, setInstagram] = useState<any>(cityguide?.instagram || "");
  const [youtube, setYoutube] = useState<any>(cityguide?.youtube || "");

  const [hashtags, setHashtags] = useState<any>(cityguide?.hashtag || "");
  const [googleMapCode, setGoogleMapCode] = useState<any>(
    cityguide?.google_map_code || ""
  );
  const [latitude, setLatitude] = useState<any>(cityguide?.latitude || "");
  const [longitude, setLongitude] = useState<any>(cityguide?.longitude || "");
  const [formattedAddress, setFormattedAddress] = useState<any>(
    cityguide?.formatted_address || ""
  );

  const [featured, setFeatured] = useState<any>(cityguide?.featured || "no");
  const [promoted, setPromoted] = useState<any>(
    cityguide?.promoted ? cityguide?.promoted : "no"
  );
  const [cityguideStatus, setCityGuideStatus] = useState<any>(
    cityguide?.status ?? 1
  );
  const [expo, setExpo] = useState<any>(cityguide?.expo ?? 0);

  const [description, setDescription] = useState<any>(cityguide?.description || "");
  const [pricing, setPricing] = useState<any>(cityguide?.Pricings || []);

  const [showDescriptionModal, setShowDescriptionModal] = useState<any>(false);

  const [error, setError] = useState<any>(false);
  const [message, setErrorMessage] = useState<any>("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState<any>(false);

  const cityGuideRoutes = "/data/city/guide";

  const resetNotices = () => {
    setError(false);
    setSuccess(false);
    setErrorMessage("");
  };

  const clearMessages = () => {
    if (error || success) resetNotices();
  };

  const respond = (isError: any, msg: any) => {
    setError(isError);
    setLoading(false);
    setSuccess(!isError);
    setErrorMessage(msg || "");
  };

  const updateOneCityGuideHandler = async (e: any) => {
    e.preventDefault();
    resetNotices();
    setLoading(true);

    if (!thumbnail || !thumbnailId) return respond(true, "Image required.");
    if (!title?.trim()) return respond(true, "Title is required.");
    if (!venue?.trim()) return respond(true, "Venue is required.");
    if (!startDate || !endDate || !startTime || !endTime)
      return respond(true, "Start/End date and time are required.");

    await sendDBRequest();
  };

  const sendDBRequest = async () => {
    const data = {
      country_id: country_id ? country_id : cityguide?.country_id,
      first_level_id: first_level_id || 0,
      second_level_id: second_level_id || 0,
      third_level_id: third_level_id || 0,
      fourth_level_id: fourth_level_id || 0,

      title: title?.trim(),
      slug: slugify(title),

      description: description || "",
      venue: venue || "",
      venue_capacity: venueCapacity ? Number(venueCapacity) : 0,

      start_date: startDate,
      end_date: endDate,
      start_time: startTime,
      end_time: endTime,

      thumbnail: thumbnail || defaultImage,
      image_cdn_id: thumbnailId || "",

      phone_number: phoneNumber || "",
      email_address: email || "",
      pay_link: payLink,

      whatsapp: whatsapp || "none",
      facebook: facebook || "none",
      twitter: twitter || "none",
      instagram: instagram || "none",
      youtube: youtube || "none",

      hashtag: hashtags || "none",
      audio_adv: "none",

      google_map_code: googleMapCode || "none",
      latitude: latitude || "none",
      longitude: longitude || "none",
      formatted_address: formattedAddress || "",

      country_short: "none",
      status: cityguideStatus,
      featured,
      promoted,
      expo,
      pricing,
    };

    const { message, status } = await updateOneContent({
      data_id: city_guide_id,
      data,
      content: _TYPES_.CITYGUIDE,
      position: {
        country_id,
        first_level_id,
        second_level_id,
        third_level_id,
        fourth_level_id,
      },
    });

    if (status === codeOk) respond(false, message);
    else respond(true, message);
  };

  return (
    <AddPageShell
      backRoute={cityGuideRoutes}
      eyebrow="DoSee Data • City Guide"
      title="Edit City Guide"
      subtitle={`Update a curated city guide entry for ${entry_label || "this destination"}.`}
      icon={<FiMap className="h-5 w-5" />}
      modals={
        showDescriptionModal ? (
          <GenerateDescription
            setDescription={setDescription}
            setShowDescriptionModal={setShowDescriptionModal}
          />
        ) : null
      }
      loading={loading}
      submitLabel="Save Changes"
      onSubmit={updateOneCityGuideHandler}
      onSubmitClick={resetNotices}
      message={
        <MyMessage
          error={error}
          message={message}
          success={success}
          onExpired={() => {
            setError(false);
            setSuccess(false);
          }}
          onClick={resetNotices}
        />
      }
    >
      <AddSection
        title="Cover Image"
        hint="A scenic shot for the city guide hero."
        icon={<FiImage className="h-4 w-4" />}
      >
        <ImageKitUpload
          thumbnail={thumbnail}
          thumbnailId={thumbnailId}
          setThumbnail={setThumbnail}
          setThumbnailId={setThumbnailId}
          folder={image_kit_folder(country_name, FOLDERS.CITY_GUIDE)}
        />
      </AddSection>

      <AddSection title="City Guide Details" hint="Title, venue and address.">
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-3">
          <InputField
            props={{
              id: "title",
              title: "Title",
              type: "text",
              required: true,
              value: title,
              onChange: (e: any) => {
                setTitle(e.target.value);
                clearMessages();
              },
            }}
          />
          <InputField
            props={{
              id: "venue",
              title: "Venue",
              type: "text",
              required: true,
              value: venue,
              onChange: (e: any) => {
                setVenue(e.target.value);
                clearMessages();
              },
            }}
          />
          <InputField
            props={{
              id: "venue_capacity",
              title: "Venue Capacity",
              type: "number",
              value: venueCapacity,
              onChange: (e: any) => {
                setVenueCapacity(e.target.value);
                clearMessages();
              },
            }}
          />
          <InputField
            props={{
              id: "formatted_address",
              title: "Formatted Address",
              type: "address",
              value: formattedAddress,
              onChange: (e: any) => {
                setFormattedAddress(e.target.value);
                clearMessages();
              },
            }}
          />
        </div>
      </AddSection>

      <AddSection
        title="Date & Time"
        hint="When this guide event takes place."
        icon={<FiClock className="h-4 w-4" />}
      >
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-4">
          <InputField
            props={{
              id: "start_date",
              title: "Start Date",
              type: "date",
              required: true,
              value: startDate,
              onChange: (e: any) => {
                setStartDate(e.target.value);
                clearMessages();
              },
            }}
          />
          <InputField
            props={{
              id: "end_date",
              title: "End Date",
              type: "date",
              required: true,
              value: endDate,
              onChange: (e: any) => {
                setEndDate(e.target.value);
                clearMessages();
              },
            }}
          />
          <InputField
            props={{
              id: "start_time",
              title: "Start Time",
              type: "time",
              required: true,
              value: startTime,
              onChange: (e: any) => {
                setStartTime(e.target.value);
                clearMessages();
              },
            }}
          />
          <InputField
            props={{
              id: "end_time",
              title: "End Time",
              type: "time",
              required: true,
              value: endTime,
              onChange: (e: any) => {
                setEndTime(e.target.value);
                clearMessages();
              },
            }}
          />
        </div>
      </AddSection>

      <AddSection
        title="Pricing"
        hint="Optional pricing tiers."
        icon={<FiDollarSign className="h-4 w-4" />}
      >
        <Pricing pricing={pricing} setPricing={setPricing} />
      </AddSection>

      <ContactSection
        phone={phoneNumber}
        setPhone={setPhoneNumber}
        email={email}
        setEmail={setEmail}
        payLink={payLink}
        setPayLink={setPayLink}
        clearMessages={clearMessages}
      />

      <SocialSection
        whatsapp={whatsapp}
        setWhatsapp={setWhatsapp}
        facebook={facebook}
        setFacebook={setFacebook}
        twitter={twitter}
        setTwitter={setTwitter}
        instagram={instagram}
        setInstagram={setInstagram}
        youtube={youtube}
        setYoutube={setYoutube}
        clearMessages={clearMessages}
      />

      <GeoSection
        googleMapCode={googleMapCode}
        setGoogleMapCode={setGoogleMapCode}
        latitude={latitude}
        setLatitude={setLatitude}
        longitude={longitude}
        setLongitude={setLongitude}
        clearMessages={clearMessages}
      />

      <VisibilitySection
        statusId="cityguide_status"
        setStatus={setCityGuideStatus}
        setFeatured={setFeatured}
        setPromoted={setPromoted}
        setExpo={setExpo}
        status={cityguideStatus}
        featured={featured}
        promoted={promoted}
        expo={expo}
        clearMessages={clearMessages}
      />

      <DescriptionSection
        description={description}
        setDescription={setDescription}
        hashtags={hashtags}
        setHashtags={setHashtags}
        onGenerate={() => setShowDescriptionModal(true)}
        clearMessages={clearMessages}
      />
    </AddPageShell>
  );
};

export default Edit;
